export default __webpack_public_path__ + "static/media/dashboard-connected-windows.5129b6e8.svg";